







































































































































































































































































































































import Vue from "vue";
import dayjs from "dayjs";
import store, { BankStatementStore } from "../services/BankStatementStore";
import {
  CompositeFilterDescriptor,
  filterBy,
  orderBy,
  SortDescriptor,
} from "@progress/kendo-data-query";
import { formatDate } from "@/utils/formatDates";
import MoneyDisplay from "@/components/MoneyDisplay.vue";
import BankDocumentCreatePage from "../views/BankDocumentCreatePage.vue";
import BankDocument, {BankDocumentInvoice} from "../models/BankDocument";
import IconButton from "@/components/IconButton.vue";
import SpecialDimensionButton from "@/components/SpecialDimensionButton.vue";
import ImportFromBankRemitsView from "./ImportFromBankRemitsView.vue";
import eventBus from "@/services/eventBus";
import BankRemitItem from "@/modules/bankRemit/models/BankRemitItem";
import MenuButton from "@/components/MenuButton.vue";
import { formatMoney } from "@/filters/money-format";
import configuration from "@/models/Configuration";
import NotoPdfViewer from "./NotoPdfViewer.vue";
import StimulsoftViewer from "./StimulsoftViewer.vue";
import CheckBox from "@/components/CheckBox.vue";
import invoiceStore from "@/modules/generalIngoingInvoice/services/GeneralIngoingInvoiceStore";
import { t } from "@/plugins/i18n";

interface Data {
  store: BankStatementStore;

  createPageVisible: boolean;

  sort: SortDescriptor[];
  filter: CompositeFilterDescriptor;
  isImportingRemit: boolean;
  isBalanceAll: boolean;
  isBalanceClosed: boolean;
  lastEditedBankStatementID: number;
  searchFilter: string;
  generatedDownPaymentInvoices: Array<{ code: string; invoice: number }>;
}

interface Methods {
  payRemits(items: BankRemitItem[]): void;
  importFromRemit(): void;
  editShowItems(item: BankDocument): void;
  editShowInvoiceItems(item: BankDocument): void;
  editShowCarItems(item: BankDocument): void;
  deleteInvoice(item: BankDocumentInvoice): void;
  deleteCar(item: any): void;
  paidAllItems(): void;
  setGeneratedDownPaymentInvoices(result: any): void;
  viewGeneratedDownPaymentInvoices(): void;

  editItem(item: BankDocument): void;
  create(): void;
  hideCreate(): void;
  refreshItems(selectItemId?: number): void;
  filterChange(e: { filter: CompositeFilterDescriptor }): void;
  sortChange(e: { sort: SortDescriptor[] }): void;
  paymentItemColumns(items: any[]): any;
}

interface Computed {
  options: any;
  documentColumns: any;
  documentItems: any;
  invoiceItemColumns: any;
  carItemColumns: any;
  balanceAll: number;
  balanceClosed: number;
  defaultCurrency: string;
  bankDocumentItems: BankDocument[];
}

export default Vue.extend<Data, Methods, Computed, {}>({
  components: {
    MoneyDisplay,
    BankDocumentCreatePage,
    IconButton,
    SpecialDimensionButton,
    ImportFromBankRemitsView,
    MenuButton,
    NotoPdfViewer,
    StimulsoftViewer,
    CheckBox
  },

  beforeMount(){
    eventBus.$on("pay-remits", (items)=> {
      this.payRemits(items)
    })

    eventBus.$on("cancel-import", ()=>{
      this.isImportingRemit = false;
    })
  },

  data() {
    return {
      store,

      createPageVisible: false,
      isImportingRemit: false,

      sort: [],
      filter: {
        logic: "and",
        filters: [],
      },
      isBalanceAll: false,
      isBalanceClosed: false,
      lastEditedBankStatementID: 0,
      searchFilter: '',
      generatedDownPaymentInvoices: [],
    };
  },

  methods: {
    paymentItemColumns(items: any[]) {
      const columns: any[] = [
        {
          field: "id",
          title: t("Azonosito"),
        },
        {
          field: "code",
          title: t("Prefix"),
        },
        {
          field: "invoice",
          title: t("SzamlaAzonosito"),
        },
        {
          field: "externalInvNo",
          title: t("Szamlaszam"),
        },
        {
          field: "paidCurrAmount",
          title: t("FizOsszegDev"),
          cell: "currAmount",
          headerClassName: "right_text",
        },
        {
          field: "amount",
          title: t("Osszeg"),
          cell: "amount",
          headerClassName: "right_text",
        },
        {
          field: "exchangeRate",
          title: t("Arfolyam"),
        },
        {
          field: "exchangeRateDate",
          title: t("ArfolyamDatuma"),
          type: "date",
          format: "{0: yyyy. MM. dd.}",
          className: "center_text",
          headerClassName: "center_text",
        },
        {
          field: "status",
          title: t("Allapot"),
        },
        {
          field: "accStatus",
          title: t("KonyvelesiAllapot"),
        },
        {
          field: "bodyNo",
          title: t("Alvazszam"),
        },
      ];

      if ((items || []).some((x: any) => x.prefix === "VIRI" || x.prefix === "VIRO")) {
        columns.push({
          field: "originalInvNo",
          title: t("BankStatement_EredetiSzamlaszam"),
        });
      }

      return columns;
    },

    async paidAllItems(){
      const result = await this.store.paidAllBankDocument();
      this.setGeneratedDownPaymentInvoices(result);
      this.refreshItems();
    },

    setGeneratedDownPaymentInvoices(result: any) {
      this.generatedDownPaymentInvoices = (result?.stResults ?? [])
        .filter((x: any) => x.noto > 1 && x.code && x.invoice > 1)
        .map((x: any) => ({ code: x.code, invoice: x.invoice }));
    },

    viewGeneratedDownPaymentInvoices() {
      invoiceStore.invoiceFilter = this.generatedDownPaymentInvoices;
      this.$router.push("/invoice-browser/outgoing/filtered");
    },

    async payRemits(items: BankRemitItem[]){
      const result = await this.store.payRemitItemsAsStatementItems(Number(this.$route.params.id),items)
      if(result){
        eventBus.$emit("success", t("BankStatement_SikeresenFizetve"))
        this.setGeneratedDownPaymentInvoices(result);
        this.isImportingRemit = false;
        this.refreshItems();
      }
      else eventBus.$emit("error", t("BankStatement_NemSikerultFizetni"))
    },  

    importFromRemit(): void {
      this.isImportingRemit = !this.isImportingRemit;
    },

    editShowItems(item: BankDocument): void {
      if (item.showInvoices && item.showPayments){
        //force update
        item.showPayments = false;
        item.showPayments = true;

        item.showInvoices = false;
        item.showCars = false;
      } else {
        item.showPayments = !item.showPayments;
        item.showInvoices = false;
        item.showCars = false;
      }
    },

    editShowInvoiceItems(item: BankDocument): void {
      if (!item.showInvoices && item.showPayments){
        //force update
        item.showPayments = false;
        item.showPayments = true;

        item.showInvoices = true;
        item.showCars = false;
      } else {
        item.showPayments = !item.showPayments;
        item.showInvoices = true;
        item.showCars = false;
      }
    },

    editShowCarItems(item: BankDocument): void {
      if (item.showPayments && !item.showCars){
        //force update
        item.showPayments = false;
        item.showPayments = true;

        item.showInvoices = false;
        item.showCars = true;
      } else {
        item.showPayments = !item.showPayments;
        item.showInvoices = false;
        item.showCars = true;
      }
    },

    editItem(item: BankDocument) {
      this.store.bankDocument = { ...item };
      this.store.bankDocument.bankStatementItem = { ...item.bankStatementItem }

      this.lastEditedBankStatementID = this.store.bankDocument.bankStatementItem.id;
      this.createPageVisible = true;
    },

    create() {
      if (this.store.bankDocuments.some(x => x.status == 'Feldolgozás alatt') && this.store.bankStatement.currency != this.defaultCurrency){
        eventBus.$emit("error", t("BankStatement_KeremElobbZarjaLeAFolyamatban"));
        return;
      }

      window.scrollTo(0, 0);
      this.store.bankDocument = new BankDocument();
      this.lastEditedBankStatementID = 0;
      this.createPageVisible = true;
    },

    hideCreate() {
      this.createPageVisible = false;
      this.lastEditedBankStatementID = 0;
    },

    deleteCar(item: any){
      this.store.deleteCar(item.bankStatementItemID, item.id).then(_ => {
        this.refreshItems();
      });
    },

    deleteInvoice(item: BankDocumentInvoice){
      this.store.deleteInvoicePayment(item.bankDocItem, item.code, item.invoice).then(_ => {
        this.refreshItems();
      });
    },

    async refreshItems(selectItemId?: number) {
      // SAKT169: a gépjármű részletező generálás után az űrlap (első) tételét mutatjuk tovább
      if (typeof selectItemId === "number" && selectItemId > 1) {
        this.lastEditedBankStatementID = selectItemId;
      }

      console.log(this.lastEditedBankStatementID);

      await this.store.loadBankDocumentsByStatementId(
        Number(this.$route.params.id)
      );

      if (this.lastEditedBankStatementID > 1){
        const item = this.store.bankDocuments.find(x => x.bankStatementItem.id == this.lastEditedBankStatementID);

        if (item){
          this.store.bankDocument = item;
        }
      } else {
        if (this.store.bankDocuments.length > 0){
          const item = this.store.bankDocuments[this.store.bankDocuments.length -1]
          this.store.bankDocument = item;
        }
      }
    },

    filterChange(e: { filter: CompositeFilterDescriptor }) {
      this.filter = e.filter;
    },

    sortChange(e: { sort: SortDescriptor[] }) {
      this.sort = e.sort;
    },
  },

  computed: {
    bankDocumentItems(){
      if (!this.searchFilter){
        return orderBy(
        filterBy(this.store.bankDocuments, this.filter),
        this.sort
      );
      } else {
        const items = this.store.bankDocuments.filter((x: any) => {
          return (dayjs(x.insDate).format("YYYY.MM.DD").includes(this.searchFilter)) ||
          (x.bankStatementItem.id.toString().toUpperCase().includes(this.searchFilter.toUpperCase())) ||
          (x.partner.toString().toUpperCase().includes(this.searchFilter.toUpperCase())) ||
          (x.status.toString().toUpperCase().includes(this.searchFilter.toUpperCase())) ||
          (x.accountType.toString().toUpperCase().includes(this.searchFilter.toUpperCase())) ||
          (x.user.toString().toUpperCase().includes(this.searchFilter.toUpperCase()));
        });

        return orderBy(
        filterBy(items, this.filter),
        this.sort
      );
      }
    },

    balanceAll(){
      if (this.store.bankStatement.currency != this.defaultCurrency){
        return this.store.bankDocuments.filter(x => x.status.toLocaleLowerCase() != "rontott").map(x => x.bankStatementItem.currAmount * (x.bankStatementItem.crediting ? 1 : -1)).reduce((sum, x) => sum += x, 0) + this.store.bankStatement.openBalance;
      }

      return this.store.bankDocuments.filter(x => x.status.toLocaleLowerCase() != "rontott").map(x => x.bankStatementItem.amount * (x.bankStatementItem.crediting ? 1 : -1)).reduce((sum, x) => sum += x, 0) + this.store.bankStatement.openBalance;
    },

    balanceClosed(){
      if (this.store.bankStatement.currency != this.defaultCurrency){
        return this.store.bankDocuments.filter(x => x.status.toLocaleLowerCase() == "nem módosítható").map(x => x.bankStatementItem.currAmount * (x.bankStatementItem.crediting ? 1 : -1)).reduce((sum, x) => sum += x, 0) + this.store.bankStatement.openBalance;
      }

      return this.store.bankDocuments.filter(x => x.status.toLocaleLowerCase() == "nem módosítható").map(x => x.bankStatementItem.amount * (x.bankStatementItem.crediting ? 1 : -1)).reduce((sum, x) => sum += x, 0) + this.store.bankStatement.openBalance;
    },
    
    defaultCurrency(){
      return (configuration.sysParams.defaultCurrency as any).value;
    },

    options() {
      return {
        duration: 800,
        offset: 0,
        easing: "easeInOutQuad",
      };
    },

    documentItems() {
      return orderBy(
        filterBy(this.store.bankDocuments, this.filter),
        this.sort
      );
    },

    invoiceItemColumns: () => [
      {
        field: "prefix",
        title: t("Prefix"),
      },
      {
        field: "maskedInvNo",
        title: t("SzamlaAzonosito"),
      },
      {
        field: "currAmount",
        title: t("BankStatement_FizOsszeg"),
        cell: "currAmount",
        headerClassName: "right_text",
      },
      { width: 60, cell: "itemsTemplate", filterable: false },
    ],

    carItemColumns: () => [
      {
        field: "brand",
        title: t("Gyartmany"),
      },
      {
        field: "model",
        title: t("Modell"),
      },
      {
        field: "color",
        title: t("Szin"),
      },
      {
        field: "bodyNo",
        title: t("Alvazszam"),
      },
      {
        field: "engineNo",
        title: t("Motorszam"),
      },
      {
        field: "regNum",
        title: t("Rendszam"),
      },
      {
        field: "owner",
        title: t("Tulajdonos"),
      },
      {
        field: "ownerRunning",
        title: t("Uzembentarto"),
      },
      { width: 60, cell: "newCarTemplate", filterable: false, title: t("BankStatement_UjAuto") },
      { width: 60, cell: "itemsTemplate", filterable: false },
    ],

    documentColumns: () => [
    { field: "bankStatementItem.id", title: t("Azonosito") },
      { field: "partner", title: t("Partner") },
      {
        title: t("FizOsszegDev"),
        cell: "currAmountTemplate",
        headerClassName: "right_text",
        field: "bankStatementItem.currAmount"
      },
      {
        title: t("Osszeg"),
        cell: "amountTemplate",
        headerClassName: "right_text",
        field: "bankStatementItem.amount"
      },
      { field: "status", title: t("Allapot") },
      {
        field: "accountType",
        title: t("TetelTipus"),
      },
      {
        field: "accountSubtype",
        title: t("TetelAltipus"),
      },
      {
        field: "user",
        title: t("Rogzito"),
      },
      {
        field: "insDate",
        title: t("BankStatement_RogzDat"),
        type: "date",
        format: "{0: yyyy. MM. dd.}",
        className: "center_text",
        headerClassName: "center_text",
      },
      {
        field: "exchangeRate",
        title: t("Arfolyam"),
        className: "right_text",
        headerClassName: "right_text",
        cell: 'exchangeRate'
      },
      { width: 180, cell: "itemsTemplate", filterable: false, sortable: false },
      { width: 60, cell: "editTemplate", filterable: false, sortable: false },
    ],
  },
});
